import { Injectable } from '@angular/core';
import { DealerServiceDetailsListViewModel } from '../business-entities/dealer-service-details-list-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DealerServiceDetailsViewModel } from './../business-entities/dealer-service-details-view-model';
import { DealerServiceRequestModel, DealerServiceViewModel } from './../business-entities/dealer-service-view-model';
import { SelectListItemViewModel } from './../business-entities/select-list-item-view-model';

@Injectable({
    providedIn: 'root'
})

export class DealerServiceDataService {
    constructor(private dataProvider: DataService) {
    }
    async getDealerServiceList(dealerServiceRequestModel:DealerServiceRequestModel): Promise<GenericResponse<DealerServiceDetailsListViewModel>> {
        return this.dataProvider.Post<GenericResponse<DealerServiceDetailsListViewModel>>(Urls.GetDealerServiceList, dealerServiceRequestModel).toPromise();
    }

    async getDealerServiceDetails(dealerServiceId: number, language: string): Promise<GenericResponse<DealerServiceDetailsViewModel>> {
        return this.dataProvider.Get<GenericResponse<DealerServiceDetailsViewModel>>
        (Urls.GetDealerServiceDetails, dealerServiceId, language).toPromise();
    }
    
    addDealerServices(dealerServiceViewModel: DealerServiceViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDealerService, dealerServiceViewModel).toPromise();
    }

    editDealerServices(dealerServiceViewModel: DealerServiceViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.EditDealerService, dealerServiceViewModel).toPromise();
    }

    deleteDealerService(id: number): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteDealerService, id).toPromise();
    }

    getServiceCategory(){
        return this.dataProvider.Get<GenericResponse<SelectListItemViewModel[]>>(Urls.GetServiceCategory).toPromise();
    }
 GetDealerServiceTimeDetails(dealerServiceId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>
        (Urls.GetDealerServiceTimeDetails, dealerServiceId).toPromise();
    }
}